import React from "react";
import "./LoginRequiredState.css";
import { Link } from "react-router-dom";
// import loginImg from "./login-image.jpg"; // replace with your image path

export default function LoginRequiredState() {
  return (
    <div className="LoginRequired-container">
      <h3 className="LoginRequired-title">Login Required To Continue</h3>

      <div className="LoginRequired-imageWrapper">
        <img src="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?q=80&w=1172&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Login Required" className="LoginRequired-image" />
      </div>
      <Link to="/login">
      <button className="LoginRequired-button">Login</button>
      </Link>
    </div>
  );
}
